import { CompanyShowType } from '@api';
import { TouringDataTable, useManageTableContext } from '@common*';
import { useCompanyShowsColumns } from './hooks';

type CompanyShowsTablePropsType = {
  shows: CompanyShowType[];
  isPending: boolean;
};

export const CompanyShowsTable: React.FC<CompanyShowsTablePropsType> = ({
  shows,
  isPending,
}) => {
  const { columns } = useCompanyShowsColumns();

  const { tableArguments: table } = useManageTableContext();

  return (
    <TouringDataTable<CompanyShowType>
      data-testid="company-shows-table"
      columns={columns}
      records={shows}
      {...table.pagination}
      {...table.sorting}
      fetching={isPending}
      noHeader={false}
    />
  );
};
